import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';

import TextField from '../../components/common/form/texField/textField';

import formClasses from '../../components/common/form/form.module.scss';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import useAuthDataContext from '../../auth/hooks/useAuthDataContext';
import useStyles from './styles';

export default function ConfirmCodeForm({ email, t }) {
  const classes = useStyles();
  const { confirmSignUp, goToPage, resendSignUp } = useAuthDataContext();

  const initialValues = { code: '' };

  const requiredTranslated = t('form:required');
  const ConfirmCodeSchema = Yup.object().shape({
    code: Yup.string().required(requiredTranslated),
  });

  const onSubmit = async (values, actions) => {
    const { success, errorMessage } = await confirmSignUp(email, values.code);
    if (success) {
      goToPage('/signin');
    } else {
      actions.setStatus({ msg: t(errorMessage) });
    }
  };

  const [isResendingCode, setIsResendingCode] = useState(false);

  const resendCode = async () => {
    setIsResendingCode(true);
    await resendSignUp(email);
    setIsResendingCode(false);
  };

  return (
    <div className={formClasses.container}>
      <Formik
        initialValues={initialValues}
        validationSchema={ConfirmCodeSchema}
        onSubmit={onSubmit}
      >
        {({ status, isSubmitting, isValid }) => (
          <Form
            className={classNames(formClasses.paper, formClasses.paperSmall)}
          >
            <div className={formClasses.title}>
              {t('authentication:confirmCode')}
            </div>
            <Field
              name='code'
              required
              component={TextField}
              placeholder={t('authentication:confirmationCode')}
            />

            {status && status.msg && (
              <Typography className={classes.error}>{status.msg}</Typography>
            )}

            <Button
              className={classes.submitButton}
              variant='contained'
              color='secondary'
              type='submit'
              disabled={!isValid || isSubmitting}
            >
              {t('form:submit')}
            </Button>
          </Form>
        )}
      </Formik>
      <div>
        <Link
          component='button'
          variant='button'
          color='textPrimary'
          underline='always'
          onClick={resendCode}
          disabled={isResendingCode}
        >
          {t('authentication:btnResendCode')}
        </Link>
      </div>
    </div>
  );
}

ConfirmCodeForm.propTypes = {
  t: PropTypes.func.required,
  email: PropTypes.string.required,
};
